import { UIHeading5 } from '@cian/ui-kit';
import styles from './Tab.css';
import { clsx } from 'clsx';

export interface ITab<T> {
  title: string;
  value: T;
}

interface ITabProps<T> extends ITab<T> {
  active?: boolean;
  onClick(value: T): void;
}

export function Tab<T>({ title, value, active, onClick }: ITabProps<T>) {
  return (
    <button
      className={clsx(styles['tab'], {
        [styles['tab--active']]: !!active,
      })}
      onClick={() => onClick(value)}
    >
      <div className={styles['inner']}>
        <UIHeading5 color={active ? 'primary_100' : undefined}>{title}</UIHeading5>
      </div>
    </button>
  );
}
